module.exports = __webpack_public_path__ + "img/10_29.53b2613b.png";